const baseURL = "/v1/Profissional";

const service = {
  methods: {
    $buscarProfissionais(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarProfissionais({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarProfissional(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarProfissional(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarProfissional(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    },
    $buscarCargo() {
      return this.$api().get(`${baseURL}/Cargo`);
    }
  },
};

export default service;
